module.exports = __webpack_public_path__ + "img/frame (32).6836de7d.jpg";